import React from 'react';

const Calendar: React.FC = () => {
    return <img style={{ width: '100%' }} src="/img/icons/calendar.png" />
}

export default Calendar;
